import React, { useContext, useMemo } from 'react';
import { TimeslotView, TimeslotViewProps } from './Timeslot.view';
import { PostingPlanContext } from '../../../../providers/PostingPlanProvider';
import { CalendarDataType, PostingPlanCellDataType } from '../../../../models/calendar';

export type TimeslotControllerProps = Omit<TimeslotViewProps, 'hoverRelatedHandler'> & {
  // extend props here
  categoryId: string;
};

export const TimeslotController = (props: TimeslotControllerProps): JSX.Element => {
  const { setTimeslots } = useContext(PostingPlanContext);
  const hoverRelatedHandler = (param?: boolean) => {
    //
    setTimeslots(old => {
      const newTimeslots = [...old] as CalendarDataType<PostingPlanCellDataType>;
      return newTimeslots.map(hourRow =>
        hourRow.map(cell => {
          if (cell !== undefined) {
            cell.forEach(timeslot => {
              if (timeslot.categoryId === props.categoryId) {
                timeslot.hovering = !!param;
              }
            });
          }
          return cell;
        })
      ) as CalendarDataType<PostingPlanCellDataType>;
    });
  };
  const args = {
    ...props,
    hoverRelatedHandler
  };
  return useMemo(
    () => <TimeslotView {...args} />,
    // TODO-FIX-TS-WARNINGS
    // eslint-disable-next-line
    [
      props.colour,
      props.hovering,
      props.day,
      props.time,
      props.isDragging,
      props.name,
      props.socialProfiles,
      props.timeFormat,
      props.actions,
      props.categoryId,
      props.isListView,
      props.time,
      props.onboardingContent
    ]
  );
};
